import React from "react";
import { SRLWrapper } from "simple-react-lightbox"; // Import SRLWrapper
import mannaT from "../../assets/img/gallery/thumbnail/manna-web.jpg"
import manna from "../../assets/img/gallery/manna-web.jpg"
import kuhneT from "../../assets/img/gallery/thumbnail/kuhne-web.jpg"
import kuhne from "../../assets/img/gallery/kuhne-web.jpg"
import kuruyemisT from "../../assets/img/gallery/thumbnail/kuruyemisborsasi-web.jpg"
import kuruyemis from "../../assets/img/gallery/kuruyemisborsasi-web.jpg"
import livaT from "../../assets/img/gallery/thumbnail/liva-web.jpg"
import liva from "../../assets/img/gallery/liva-web.jpg"
import lodaT from "../../assets/img/gallery/thumbnail/loda-web.jpg"
import loda from "../../assets/img/gallery/loda-web.jpg"
import arcadiumT from "../../assets/img/gallery/thumbnail/arcadium-web.jpg"
import arcadium from "../../assets/img/gallery/arcadium-web.jpg"
import cetmenT from "../../assets/img/gallery/thumbnail/cetmen-web.jpg"
import cetmen from "../../assets/img/gallery/cetmen-web.jpg"
import enzaT from "../../assets/img/gallery/thumbnail/enza-web.jpg"
import enza from "../../assets/img/gallery/enza-web.jpg"
import ergulT from "../../assets/img/gallery/thumbnail/ergul-web.jpg"
import ergul from "../../assets/img/gallery/ergul-web.jpg"
import hacibabaT from "../../assets/img/gallery/thumbnail/hacibaba-web.jpg"
import hacibaba from "../../assets/img/gallery/hacibaba-web.jpg"
import homT from "../../assets/img/gallery/thumbnail/hom-web.jpg"
import hom from "../../assets/img/gallery/hom-web.jpg"
import ideaportT from "../../assets/img/gallery/thumbnail/ideaport-web.jpg"
import ideaport from "../../assets/img/gallery/ideaport-web.jpg"
import kentparkT from "../../assets/img/gallery/thumbnail/kentpark-web.jpg"
import kentpark from "../../assets/img/gallery/kentpark-web.jpg"
import konforT from "../../assets/img/gallery/thumbnail/konfor-web.jpg"
import konfor from "../../assets/img/gallery/konfor-web.jpg"

import pakmaya from "../../assets/img/gallery/pakmaya-web.jpg"
import pakmayaPpd from "../../assets/img/gallery/pakmaya-ppd-web.jpg"
import pakmayaMy from "../../assets/img/gallery/pakmaya-my-web.jpg"
import oracle from "../../assets/img/gallery/oracle-web.jpg"
import mehmetcik from "../../assets/img/gallery/mehmetcik-web.jpg"
import matbuu from "../../assets/img/gallery/matbuu-web.jpg"
import linkplus from "../../assets/img/gallery/linkplus-web.jpg"
import ideanest from "../../assets/img/gallery/ideanest-web.jpg"
import pakmayaT from "../../assets/img/gallery/thumbnail/pakmaya-web.jpg"
import pakmayaPpdT from "../../assets/img/gallery/thumbnail/pakmaya-ppd-web.jpg"
import pakmayaMyT from "../../assets/img/gallery/thumbnail/pakmaya-my-web.jpg"
import oracleT from "../../assets/img/gallery/thumbnail/oracle-web.jpg"
import mehmetcikT from "../../assets/img/gallery/thumbnail/mehmetcik-web.jpg"
import matbuuT from "../../assets/img/gallery/thumbnail/matbuu-web.jpg"
import linkplusT from "../../assets/img/gallery/thumbnail/linkplus-web.jpg"
import ideanestT from "../../assets/img/gallery/thumbnail/ideanest-web.jpg"


import seokuruyemisT from "../../assets/img/gallery/thumbnail/kuruyemisborsasi-web.jpg"
import seokuruyemis from "../../assets/img/gallery/kuruyemisborsasi-web.jpg"
import seolivaT from "../../assets/img/gallery/thumbnail/liva-web.jpg"
import seoliva from "../../assets/img/gallery/liva-web.jpg"
import seolodaT from "../../assets/img/gallery/thumbnail/loda-web.jpg"
import seoloda from "../../assets/img/gallery/loda-web.jpg"
import seoarcadiumT from "../../assets/img/gallery/thumbnail/arcadium-web.jpg"
import seoarcadium from "../../assets/img/gallery/arcadium-web.jpg"
import seocetmenT from "../../assets/img/gallery/thumbnail/cetmen-web.jpg"
import seocetmen from "../../assets/img/gallery/cetmen-web.jpg"
import seoergulT from "../../assets/img/gallery/thumbnail/ergul-web.jpg"
import seoergul from "../../assets/img/gallery/ergul-web.jpg"
import seohacibabaT from "../../assets/img/gallery/thumbnail/hacibaba-web.jpg"
import seohacibaba from "../../assets/img/gallery/hacibaba-web.jpg"
import seokonforT from "../../assets/img/gallery/thumbnail/konfor-web.jpg"
import seokonfor from "../../assets/img/gallery/konfor-web.jpg"



import smlivaT from "../../assets/img/gallery/thumbnail/liva-sm.jpg"
import smliva from "../../assets/img/gallery/liva-sm.jpg"
import smlodaT from "../../assets/img/gallery/thumbnail/loda-sm.jpg"
import smloda from "../../assets/img/gallery/loda-sm.jpg"
import smmaidanT from "../../assets/img/gallery/thumbnail/maidan-sm.jpg"
import smmaidan from "../../assets/img/gallery/maidan-sm.jpg"
import smmannaT from "../../assets/img/gallery/thumbnail/manna-sm.jpg"
import smmanna from "../../assets/img/gallery/manna-sm.jpg"
import smarcadiumT from "../../assets/img/gallery/thumbnail/arcadium-sm.jpg"
import smarcadium from "../../assets/img/gallery/arcadium-sm.jpg"
import smcetmenT from "../../assets/img/gallery/thumbnail/cetmen-sm.jpg"
import smcetmen from "../../assets/img/gallery/cetmen-sm.jpg"
import smgs1T from "../../assets/img/gallery/thumbnail/gs1-sm.jpg"
import smgs1 from "../../assets/img/gallery/gs1-sm.jpg"
import smhacibabakahveciT from "../../assets/img/gallery/thumbnail/hacibaba-sm.jpg"
import smhacibabakahveci from "../../assets/img/gallery/hacibaba-sm.jpg"
import smhacibabaT from "../../assets/img/gallery/thumbnail/hacibaba-kuruyemis-sm.jpg"
import smhacibaba from "../../assets/img/gallery/hacibaba-kuruyemis-sm.jpg"
import smidasT from "../../assets/img/gallery/thumbnail/idas-sm.jpg"
import smidas from "../../assets/img/gallery/idas-sm.jpg"
import smistikbalT from "../../assets/img/gallery/thumbnail/istikbal-sm.jpg"
import smistikbal from "../../assets/img/gallery/istikbal-sm.jpg"
import smkentparkT from "../../assets/img/gallery/thumbnail/kentpark-sm.jpg"
import smkentpark from "../../assets/img/gallery/kentpark-sm.jpg"
import smkipaT from "../../assets/img/gallery/thumbnail/kipa-sm.jpg"
import smkipa from "../../assets/img/gallery/kipa-sm.jpg"
import smkonforT from "../../assets/img/gallery/thumbnail/konfor-sm.jpg"
import smkonfor from "../../assets/img/gallery/konfor-sm.jpg"
import smkuhneT from "../../assets/img/gallery/thumbnail/kuhne-sm.jpg"
import smkuhne from "../../assets/img/gallery/kuhne-sm.jpg"

import smmatbuu from "../../assets/img/gallery/matbuu-sm.jpg"
import smonetower from "../../assets/img/gallery/onetower-sm.jpg"
import smpakmayaMy from "../../assets/img/gallery/pakmaya-my-sm.jpg"
import smpakmayaPpd from "../../assets/img/gallery/pakmaya-ppd-sm.jpg"
import smpakmaya from "../../assets/img/gallery/pakmaya-sm.jpg"
import smmatbuuT from "../../assets/img/gallery/thumbnail/matbuu-sm.jpg"
import smonetowerT from "../../assets/img/gallery/thumbnail/onetower-sm.jpg"
import smpakmayaMyT from "../../assets/img/gallery/thumbnail/pakmaya-my-sm.jpg"
import smpakmayaPpdT from "../../assets/img/gallery/thumbnail/pakmaya-ppd-sm.jpg"
import smpakmayaT from "../../assets/img/gallery/thumbnail/pakmaya-sm.jpg"

import lovaT from "../../assets/img/gallery/lova-sm.jpg"
import lova from "../../assets/img/gallery/lova-sm-detail.jpg"
import nextlevelT from "../../assets/img/gallery/nextlevel-sm.jpg"
import nextlevel from "../../assets/img/gallery/nextlevel-sm-detail.jpg"
import tanotoT from "../../assets/img/gallery/tanoto-sm.jpg"
import tanoto from "../../assets/img/gallery/tanoto-sm-detail.jpg"
import nillsT from "../../assets/img/gallery/nills-sm.jpg"
import nills from "../../assets/img/gallery/nills-sm-detail.jpg"
import smartT from "../../assets/img/gallery/smart-sm.jpg"
import smart from "../../assets/img/gallery/smart-sm-detail.jpg"
import weltewT from "../../assets/img/gallery/weltew-sm.jpg"
import weltew from "../../assets/img/gallery/weltew-sm-detail.jpg"


const List = () => {
  const imgs = [
    {
      thumb: lovaT,
      img: lova,
      head: 'Lova Yatak',
      alt: 'Lova Yatak Sosyal Medya Yönetimi',
    },
    {
      thumb: nextlevelT,
      img: nextlevel,
      head: 'Next Level',
      alt: 'Next Level Sosyal Medya Yönetimi',
    },
    {
      thumb: tanotoT,
      img: tanoto,
      head: 'Tanoto',
      alt: 'Tanoto Sosyal Medya Yönetimi',
    },
    {
      thumb: nillsT,
      img: nills,
      head: "Nill's",
      alt: "Nill's Sosyal Medya Yönetimi",
    },
    {
      thumb: smartT,
      img: smart,
      head: 'Smart Energy',
      alt: 'Smart Energy Sosyal Medya Yönetimi',
    },
    {
      thumb: weltewT,
      img: weltew,
      head: 'Weltew Home',
      alt: 'Weltew Home Sosyal Medya Yönetimi',
    },
    {
      thumb: pakmayaT,
      img: pakmaya,
      head: 'Pakmaya',
      alt: 'Pakmaya Websitesi Geliştirme',
    },
    {
      thumb: pakmayaPpdT,
      img: pakmayaPpd,
      head: 'Pakmaya Profesyoneller Dünyası',
      alt: 'Pakmaya Profesyoneller Dünyası Websitesi Geliştirme',
    },
    {
      thumb: pakmayaMyT,
      img: pakmayaMy,
      head: 'Pakmaya Mutfağın Yıldızı',
      alt: 'Pakmaya Mutfağın Yıldızı Websitesi Geliştirme',
    },
    {
      thumb: oracleT,
      img: oracle,
      head: 'Oracle',
      alt: 'Oracle Websitesi Geliştirme',
    },
    {
      thumb: mehmetcikT,
      img: mehmetcik,
      head: 'Mehmetçik Vakfı',
      alt: 'Mehmetçik Vakfı Websitesi Geliştirme',
    },
    {
      thumb: matbuuT,
      img: matbuu,
      head: 'Matbuu',
      alt: 'Matbuu Websitesi Geliştirme',
    },
    {
      thumb: linkplusT,
      img: linkplus,
      head: 'Linkplus',
      alt: 'Linkplus Websitesi Geliştirme',
    },
    {
      thumb: ideanestT,
      img: ideanest,
      head: 'Ideanest',
      alt: 'Ideanest Websitesi Geliştirme',
    },
    {
      thumb: mannaT,
      img: manna,
      head: 'Manna Hotel',
      alt: 'Manna Hotel Websitesi Geliştirme',
    },
    {
      thumb: kuhneT,
      img: kuhne,
      head: 'Kuhne',
      alt: 'Kuhne Websitesi Geliştirme',
    },
    {
      thumb: kuruyemisT,
      img: kuruyemis,
      head: 'Kuruyemiş Borsası',
      alt: 'Kuruyemiş Borsası Websitesi Geliştirme',
    },
    {
      thumb: livaT,
      img: liva,
      head: 'Liva Pastacılık',
      alt: 'Liva Pastacılık Websitesi Geliştirme',
    },
    {
      thumb: lodaT,
      img: loda,
      head: 'Loda',
      alt: 'Loda Websitesi Geliştirme',
    },
    {
      thumb: arcadiumT,
      img: arcadium,
      head: 'Arcadium AVM',
      alt: 'Arcadium AVM Websitesi Geliştirme',
    },
    {
      thumb: cetmenT,
      img: cetmen,
      head: 'Çetmen',
      alt: 'Çetmen Websitesi Geliştirme',
    },
    {
      thumb: enzaT,
      img: enza,
      head: 'Enza',
      alt: 'Enza Websitesi Geliştirme',
    },
    {
      thumb: ergulT,
      img: ergul,
      head: 'Ergül Keskin',
      alt: 'Ergül Keskin Websitesi Geliştirme',
    },
    {
      thumb: hacibabaT,
      img: hacibaba,
      head: 'Kahveci Hacıbaba',
      alt: 'Kahveci Hacıbaba Websitesi Geliştirme',
    },

    {
      thumb: homT,
      img: hom,
      head: 'Hom',
      alt: 'Hom Websitesi Geliştirme',
    },
    {
      thumb: ideaportT,
      img: ideaport,
      head: 'İdeaport',
      alt: 'İdeaport Websitesi Geliştirme',
    },
    {
      thumb: kentparkT,
      img: kentpark,
      head: 'Kentpark AVM',
      alt: 'Kentpark AVM Websitesi Geliştirme',
    },
    {
      thumb: konforT,
      img: konfor,
      head: 'Konfor',
      alt: 'Konfor Websitesi Geliştirme',
    },
    {
      thumb: seokuruyemisT,
      img: seokuruyemis,
      head: 'Kuruyemiş Borsası',
      alt: 'Kuruyemiş Borsası Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seolivaT,
      img: seoliva,
      head: 'Liva Pastacılık',
      alt: 'Liva Pastacılık Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seolodaT,
      img: seoloda,
      head: 'Loda',
      alt: 'Loda Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seoarcadiumT,
      img: seoarcadium,
      head: 'Arcadium AVM',
      alt: 'Arcadium AVM Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seocetmenT,
      img: seocetmen,
      head: 'Çetmen',
      alt: 'Çetmen Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seoergulT,
      img: seoergul,
      head: 'Ergül Keskin',
      alt: 'Ergül Keskin Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seohacibabaT,
      img: seohacibaba,
      head: 'Kahveci Hacıbaba',
      alt: 'Kahveci Hacıbaba Arama Optimizasyonu Çalışması',
    },
    {
      thumb: seokonforT,
      img: seokonfor,
      head: 'Konfor',
      alt: 'Konfor Arama Optimizasyonu Çalışması',
    },

    {
      thumb: smlivaT,
      img: smliva,
      head: 'Liva Pastacılık',
      alt: 'Liva Pastacılık Sosyal Medya Yönetimi',
    },
    {
      thumb: smlodaT,
      img: smloda,
      head: 'Loda',
      alt: 'Loda Sosyal Medya Yönetimi',
    },
    {
      thumb: smmaidanT,
      img: smmaidan,
      head: 'Maidan',
      alt: 'Maidan Sosyal Medya Yönetimi',
    },
    {
      thumb: smmannaT,
      img: smmanna,
      head: 'Manna Hotel',
      alt: 'Manna Hotel Sosyal Medya Yönetimi',
    },
    {
      thumb: smarcadiumT,
      img: smarcadium,
      head: 'Arcadium AVM',
      alt: 'Arcadium AVM Sosyal Medya Yönetimi',
    },
    {
      thumb: smcetmenT,
      img: smcetmen,
      head: 'Çetmen',
      alt: 'Çetmen Sosyal Medya Yönetimi',
    },
    {
      thumb: smgs1T,
      img: smgs1,
      head: 'GS1',
      alt: 'GS1 Sosyal Medya Yönetimi',
    },
    {
      thumb: smhacibabakahveciT,
      img: smhacibabakahveci,
      head: 'Kahveci Hacıbaba',
      alt: 'Kahveci Hacıbaba Sosyal Medya Yönetimi',
    },
    {
      thumb: smhacibabaT,
      img: smhacibaba,
      head: 'Hacıbaba Kuruyemiş',
      alt: 'Hacıbaba Kuruyemiş Sosyal Medya Yönetimi',
    },
    {
      thumb: smidasT,
      img: smidas,
      head: 'İdaş',
      alt: 'İdaş Sosyal Medya Yönetimi',
    },
    {
      thumb: smistikbalT,
      img: smistikbal,
      head: 'İstikbal Mobilya',
      alt: 'İstikbal Mobilya Sosyal Medya Yönetimi',
    },
    {
      thumb: smkentparkT,
      img: smkentpark,
      head: 'Kentpark AVM',
      alt: 'Kentpark AVM Sosyal Medya Yönetimi',
    },
    {
      thumb: smkipaT,
      img: smkipa,
      head: 'Kipa AVM',
      alt: 'Kipa AVM Sosyal Medya Yönetimi',
    },
    {
      thumb: smkonforT,
      img: smkonfor,
      head: 'Konfor',
      alt: 'Konfor Sosyal Medya Yönetimi',
    },
    {
      thumb: smkuhneT,
      img: smkuhne,
      head: 'Kuhne',
      alt: 'Kuhne Sosyal Medya Yönetimi',
    },
    {
      thumb: smmatbuuT,
      img: smmatbuu,
      head: 'Matbuu',
      alt: 'Matbuu Sosyal Medya Yönetimi',
    },
    {
      thumb: smonetowerT,
      img: smonetower,
      head: 'One Tower',
      alt: 'One Tower Sosyal Medya Yönetimi',
    },
    {
      thumb: smpakmayaT,
      img: smpakmaya,
      head: 'Pakmaya',
      alt: 'Pakmaya Sosyal Medya Yönetimi',
    },
    {
      thumb: smpakmayaMyT,
      img: smpakmayaMy,
      head: 'Pakmaya Mutfağın Yıldızı',
      alt: 'Pakmaya Mutfağın Yıldızı Sosyal Medya Yönetimi',
    },
    {
      thumb: smpakmayaPpdT,
      img: smpakmayaPpd,
      head: 'Pakmaya Profesyoneller Dünyası',
      alt: 'Pakmaya Profesyoneller Dünyası Sosyal Medya Yönetimi',
    }
  ]

  return (
    imgs.map((item, i) => {
      return (
        <div key={i} className="image">
          <div className="hover">
            <a href={item.img} className="thumb" data-attribute="SRL">
              <img alt={item.alt} src={item.thumb} />
            </a>
          </div>
          <p className="img-head">{item.head}</p>
          <p>{item.alt}</p>
        </div>
      )
    })
  );
}



function AllGallery() {
  return (
    <SRLWrapper>
      <div className="gallery container">
        <List />
      </div>
    </SRLWrapper>
  );
}


export default AllGallery;